var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAccountCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "account_circle_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#account_circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M3.899 11.399a6.957 6.957 0 0 1 1.9-1.025c.7-.25 1.433-.375 2.2-.375.766 0 1.5.125 2.2.375.7.25 1.333.591 1.9 1.025.389-.456.691-.972.908-1.55a5.225 5.225 0 0 0 .325-1.85c0-1.478-.52-2.736-1.558-3.775-1.04-1.04-2.298-1.559-3.775-1.559-1.478 0-2.736.52-3.775 1.559-1.04 1.039-1.559 2.297-1.559 3.775 0 .655.109 1.272.325 1.85.217.578.52 1.094.909 1.55Zm4.1-2.734c-.656 0-1.209-.225-1.659-.675-.45-.45-.675-1.002-.675-1.658 0-.656.225-1.208.675-1.658.45-.45 1.003-.675 1.659-.675.655 0 1.208.225 1.658.675.45.45.675 1.002.675 1.658 0 .656-.225 1.208-.675 1.658-.45.45-1.003.675-1.658.675Zm0 6a6.492 6.492 0 0 1-2.6-.525 6.732 6.732 0 0 1-2.117-1.425A6.733 6.733 0 0 1 1.857 10.6a6.492 6.492 0 0 1-.525-2.6c0-.923.175-1.79.525-2.6a6.732 6.732 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425a6.492 6.492 0 0 1 2.6-.525c.922 0 1.789.175 2.6.525.81.35 1.516.825 2.116 1.425.6.6 1.075 1.306 1.425 2.117.35.81.525 1.677.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 0 1-1.425 2.116c-.6.6-1.305 1.075-2.116 1.425a6.492 6.492 0 0 1-2.6.525Z"
}))));
export default SvgAccountCircle;